/**
 * Environment variables.
 *
 * Never make this dynamic: Vite needs `import.meta.env.*` syntax to build envs
 * statically.
 *
 * Ignoring test coverage for these variables, as there's no functional value in
 * gating coverage here.
 */
/* istanbul ignore next */
export const variables = {
  VITE_ADA_OKTA_CLIENT_ID: import.meta.env.VITE_ADA_OKTA_CLIENT_ID,
  VITE_ADA_OKTA_DOMAIN: import.meta.env.VITE_ADA_OKTA_DOMAIN,
  VITE_ADA_OKTA_ISSUER: import.meta.env.VITE_ADA_OKTA_ISSUER,
  VITE_ADA_OKTA_HELP_URL: import.meta.env.VITE_ADA_OKTA_HELP_URL,
  VITE_ADA_PULSE_INSIGHTS_TOKEN: import.meta.env.VITE_ADA_PULSE_INSIGHTS_TOKEN,
  VITE_WMG_OKTA_CLIENT_ID: import.meta.env.VITE_WMG_OKTA_CLIENT_ID,
  VITE_WMG_OKTA_DOMAIN: import.meta.env.VITE_WMG_OKTA_DOMAIN,
  VITE_WMG_OKTA_ISSUER: import.meta.env.VITE_WMG_OKTA_ISSUER,
  VITE_WMG_OKTA_HELP_URL: import.meta.env.VITE_WMG_OKTA_HELP_URL,
  VITE_WMG_PULSE_INSIGHTS_TOKEN: import.meta.env.VITE_WMG_PULSE_INSIGHTS_TOKEN,
  ADA_BASE_URL: import.meta.env.ADA_BASE_URL,
  WMG_BASE_URL: import.meta.env.WMG_BASE_URL,
  VITE_NR_ACCOUNT_ID: import.meta.env.VITE_NR_ACCOUNT_ID,
  VITE_NR_BEACON: import.meta.env.VITE_NR_BEACON,
  VITE_NR_LICENSE_KEY: import.meta.env.VITE_NR_LICENSE_KEY,
  VITE_NR_AGENT_ID: import.meta.env.VITE_NR_AGENT_ID,
  VITE_NR_APPLICATION_ID: import.meta.env.VITE_NR_APPLICATION_ID,
  VITE_NR_TRUST_KEY: import.meta.env.VITE_NR_TRUST_KEY,
  VITE_AMPLITUDE_API_KEY: import.meta.env.VITE_AMPLITUDE_API_KEY,
  VITE_AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY: import.meta.env
    .VITE_AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY,
  VITE_AMPLITUDE_EXPERIMENT_PROXY_URL: import.meta.env
    .VITE_AMPLITUDE_EXPERIMENT_PROXY_URL,
  VITE_I18N_DEBUG: import.meta.env.VITE_I18N_DEBUG,
  VITE_REACT_QUERY_DEVTOOLS_ENABLED: import.meta.env
    .VITE_REACT_QUERY_DEVTOOLS_ENABLED,
  VITE_EXTRACT_LANGUAGE: import.meta.env.VITE_EXTRACT_LANGUAGE,

  // ADA SETTINGS
  VITE_CONTAINER_SETTINGS_ENABLED: import.meta.env
    .VITE_CONTAINER_SETTINGS_ENABLED,
  VITE_CONTAINER_SETTINGS_PSSF_ENABLED: import.meta.env
    .VITE_CONTAINER_SETTINGS_PSSF_ENABLED,
  VITE_CONTAINER_SETTINGS_DROPDOWN_PAGINATION_ENABLED: import.meta.env
    .VITE_CONTAINER_SETTINGS_DROPDOWN_PAGINATION_ENABLED,
  VITE_CONTAINER_SETTINGS_SUBLABEL_REQUEST_ENABLED: import.meta.env
    .VITE_CONTAINER_SETTINGS_SUBLABEL_REQUEST_ENABLED,

  VITE_CONTAINER_PROFILE_ENABLED: import.meta.env
    .VITE_CONTAINER_PROFILE_ENABLED,
  VITE_BRAND: import.meta.env.VITE_BRAND,
  VITE_WMG_ASSET_PERFORMANCE_ENABLED:
    import.meta.env.VITE_WMG_ASSET_PERFORMANCE_ENABLED || '',
  VITE_CONTAINER_DDEX_CONSOLE_ENABLED: import.meta.env
    .VITE_CONTAINER_DDEX_CONSOLE_ENABLED,
  VITE_WMG_TRACK_DETAILS_ENABLED:
    import.meta.env.VITE_WMG_TRACK_DETAILS_ENABLED || '',
  VITE_WMG_TRACK_PRE_RELEASES_ENABLED:
    import.meta.env.VITE_WMG_TRACK_PRE_RELEASES_ENABLED || '',
  VITE_WMG_TRACK_SET_BENCHMARKS_ENABLED:
    import.meta.env.VITE_WMG_TRACK_SET_BENCHMARKS_ENABLED || '',
  VITE_WMG_TRACK_COMPARE_BENCHMARK_ENABLED:
    import.meta.env.VITE_WMG_TRACK_COMPARE_BENCHMARK_ENABLED || '',
  VITE_WMG_ARTIST_CONTACTS_ENABLED:
    import.meta.env.VITE_WMG_ARTIST_CONTACTS_ENABLED || '',
  VITE_WMG_FRONTEND_CAMPAIGN_BENCHMARKS:
    import.meta.env.VITE_WMG_FRONTEND_CAMPAIGN_BENCHMARKS || '',
  VITE_WMG_ARTIST_COLLABORATOR_TRACKS_ENABLED:
    import.meta.env.VITE_WMG_ARTIST_COLLABORATOR_TRACKS_ENABLED || '',
  VITE_WMG_EMBED_PERFORMANCE_DASHBOARD_URL:
    import.meta.env.VITE_WMG_EMBED_PERFORMANCE_DASHBOARD_URL || '',
  VITE_WMG_EMBED_MARKETING_ANOMALY_DETECTION_DASHBOARD_URL:
    import.meta.env.VITE_WMG_EMBED_MARKETING_ANOMALY_DETECTION_DASHBOARD_URL ||
    '',
  VITE_WMG_EMBED_MARKETING_SHORT_TERM_FORECASTING_DASHBOARD_URL:
    import.meta.env
      .VITE_WMG_EMBED_MARKETING_SHORT_TERM_FORECASTING_DASHBOARD_URL || '',
  VITE_WMG_EMBED_MARKETING_KEY_MOMENTS_DASHBOARD_URL:
    import.meta.env.VITE_WMG_EMBED_MARKETING_KEY_MOMENTS_DASHBOARD_URL || '',
  VITE_WMG_EMBED_MARKETING_AUTOMATED_CAMPAIGNS_DASHBOARD_URL:
    import.meta.env
      .VITE_WMG_EMBED_MARKETING_AUTOMATED_CAMPAIGNS_DASHBOARD_URL || '',
  VITE_WMG_MARKETING_DIGITAL_CAMPAIGN_PERFORMANCE_DASHBOARD:
    import.meta.env.VITE_WMG_MARKETING_DIGITAL_CAMPAIGN_PERFORMANCE_DASHBOARD ||
    '',
  VITE_WMG_MARKETING_ANOMALY_DASHBOARD_ENABLED:
    import.meta.env.VITE_WMG_MARKETING_ANOMALY_DASHBOARD_ENABLED || '',
  VITE_WMG_HOMEPAGE_EMBED_URL:
    import.meta.env.VITE_WMG_HOMEPAGE_EMBED_URL || '',
  VITE_WMG_USER_MANAGEMENT: import.meta.env.VITE_WMG_USER_MANAGEMENT || '',
  VITE_WMG_RELEASE_MANAGEMENT:
    import.meta.env.VITE_WMG_RELEASE_MANAGEMENT || '',
  VITE_WMG_DIGITAL_CAMPAIGNS_MEDIA_PLANNING_ENABLED:
    import.meta.env.VITE_WMG_DIGITAL_CAMPAIGNS_MEDIA_PLANNING_ENABLED || '',
  VITE_WMG_DATA_MUSIC_IQ_CHATBOT_ENABLED:
    import.meta.env.VITE_WMG_DATA_MUSIC_IQ_CHATBOT_ENABLED || '',
  VITE_WMG_DIGITAL_CAMPAIGNS_EMBED_DASHBOARD_ENABLED:
    import.meta.env.VITE_WMG_DIGITAL_CAMPAIGNS_EMBED_DASHBOARD_ENABLED || '',
  VITE_WMG_SUPPORT_HUB_URL: import.meta.env.VITE_WMG_SUPPORT_HUB_URL || '',
  VITE_WMG_PRODUCT_GUIDE_URL: import.meta.env.VITE_WMG_PRODUCT_GUIDE_URL || '',
  VITE_WMG_FEEDBACK_URL: import.meta.env.VITE_WMG_FEEDBACK_URL || '',
};
